var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPillarIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 309.231,
    height: 823.819,
    viewBox: "0 0 309.231 823.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "pillar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "pillar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "pillar"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.749 822.319 306.263 822.319 293.214 804.611 19.661 805.077 4.749 822.319",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.156,695.393c-2.966,3.347-2.155,6.185-.603,8.187,1.611,2.078,4.195,3.165,6.825,3.151,0,0,177.37-.917,177.37-.917.935-.283,10.145-4.245,1.748-11.942",
    fill: "#efefef",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.078,693.698l-182.679.466v-217.631l182.679-.466-.582,217.805M76.317,476.618c0,47.244,1.161,176.584.933,188.974-.193,16.919,25.534,16.803,25.663,0,.293-9.468-.467-141.731-.467-188.974M121.029,477.113c0,47.244.982,177.143.619,187.52-.193,16.919,25.534,16.803,25.663,0,.293-9.468-.467-141.731-.467-188.974M165.112,475.543c0,47.244.838,175.337.933,188.974-.193,16.919,25.534,16.803,25.663,0,.293-9.468-.467-188.974-.467-188.974M209.404,475.194c0,47.244,1.295,178.597.933,188.974-.193,16.919,25.534,16.803,25.663,0,.293-9.468-.467-141.731-.467-188.974",
    fill: "#efefef",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.399,694.164h0c-1.197-.021-2.38.398-3.243,1.229",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.059,
    y1: 735.057,
    x2: 264.204,
    y2: 734.358,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.642,
    y1: 753.349,
    x2: 275.505,
    y2: 752.417,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.875,
    y1: 745.31,
    x2: 263.389,
    y2: 744.96,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.855,
    y1: 720.028,
    x2: 273.525,
    y2: 719.329,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7,752.3c.85-1.033,1.893-2.01,1.631-3.903-.306-1.302-.993-2.599-2.214-3.146-1.041-.466-2.214-.233-3.961-.291,5.825-.32,8.376-7.159.728-10.631.336-.797,10.955-14.237,9.874-15.349-.654-.673-4.248-1.41-5.136-1.714-1.741-.596-3.469-1.229-5.182-1.899-3.1-1.212-6.179-2.558-8.888-4.491s-5.049-4.505-6.234-7.615",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.428,753.232c-6.058-.058-9.612-7.922,2.629-7.88-9.095-1.79-6.47-9.282-.969-10.294-.336-.797-10.714-14.574-9.633-15.686.654-.673,4.248-1.41,5.136-1.714,1.741-.596,3.469-1.229,5.182-1.899,3.1-1.212,6.179-2.558,8.888-4.491s5.049-4.505,6.234-7.615",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.49,752.398c10.131-.038,6.928,9.225-.224,8.821l-240.589.988c-7.151.404-10.355-8.858-.224-8.821",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.496,
    y1: 719.213,
    x2: 246.379,
    y2: 705.232,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 238.224,
    y1: 719.213,
    x2: 238.224,
    y2: 706.048,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.535,
    y1: 719.562,
    x2: 230.535,
    y2: 706.048,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.263,
    y1: 719.446,
    x2: 222.379,
    y2: 705.931,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 719.605,
    x2: 214.857,
    y2: 706.064,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.524,
    y1: 719.605,
    x2: 206.524,
    y2: 706.064,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 198.569,
    y1: 719.065,
    x2: 198.569,
    y2: 705.9,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.88,
    y1: 719.415,
    x2: 190.88,
    y2: 705.9,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.608,
    y1: 719.298,
    x2: 182.724,
    y2: 705.784,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.306,
    y1: 719.457,
    x2: 175.202,
    y2: 705.916,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.869,
    y1: 719.457,
    x2: 166.869,
    y2: 705.916,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 159.061,
    y1: 719.324,
    x2: 159.061,
    y2: 706.159,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.372,
    y1: 719.673,
    x2: 151.372,
    y2: 706.159,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.1,
    y1: 719.557,
    x2: 143.217,
    y2: 706.042,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.799,
    y1: 719.716,
    x2: 135.695,
    y2: 706.175,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.362,
    y1: 719.716,
    x2: 127.362,
    y2: 706.175,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 118.854,
    y1: 719.722,
    x2: 118.854,
    y2: 706.557,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.165,
    y1: 720.072,
    x2: 111.165,
    y2: 706.557,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.893,
    y1: 719.955,
    x2: 103.009,
    y2: 706.441,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.592,
    y1: 720.114,
    x2: 95.487,
    y2: 706.573,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.154,
    y1: 720.114,
    x2: 87.154,
    y2: 706.573,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 79.443,
    y1: 719.523,
    x2: 79.443,
    y2: 706.358,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.754,
    y1: 719.872,
    x2: 71.754,
    y2: 706.358,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.482,
    y1: 719.756,
    x2: 63.598,
    y2: 706.241,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.868,776.926c2.679-2.104,7.064-.943,8.82,1.976s1.054,6.911-1.169,9.492c-1.378,1.6-3.28,2.74-5.341,3.201-3.781.846-7.755-.604-10.928-2.828s-5.745-5.18-8.556-7.847c-15.896-15.082-35.766-18.746-58.068-18.972-7.321.225-27.821-1.802-33.173,11.4-.998,2.458-1.37,5.121-1.63,7.761-.514,5.221-.522,10.861,2.366,15.241,2.453,3.721,6.706,5.966,11.069,6.879,4.363.913,8.879.64,13.32.253,6.215-1.01,8.419-7.075,8.499-9.32.215-5.993-.086-12.798-5.356-15.66-2.097-1.139-4.539-1.464-6.924-1.543-3.24-.108-6.651.254-9.339,2.067s-4.375,5.417-3.141,8.415c1.326,3.222,5.976,6.985,14.221,3.216",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.924,804.198c2.258.432,4.565.708,6.857.528,5.725-.45,13.994-3.515,17.342-8.181s8.491-18.7-1.415-29.313c-4.549-4.65-13.9-5.476-16.274-5.458-5.38.041-10.127,1.844-13.039,6.368-1.818,2.824-3.156,7.994-2.333,11.25s2.307,6.354,5.188,9.374",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.307,761.811c7.621-.112,18.041.841,25.07,4.962,1.477.866,2.937,1.767,4.424,2.618,22.939,13.121,28.22,33.188,45.123,34.809",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.729,762.094c7.621-.112,18.041.841,25.07,4.962,1.477.866,2.937,1.767,4.424,2.618,22.939,13.121,28.441,33.359,45.343,34.98",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,762.271c7.621-.112,20.282,5.927,21.768,6.777,22.939,13.121,26.534,33.949,43.436,35.57",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.721,778.501c31.093,11.088,27.002,24.63,43.904,26.251",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "f",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.052,777.633c-2.679-2.104-7.064-.943-8.82,1.976s-1.054,6.911,1.169,9.492c1.378,1.6,3.28,2.74,5.341,3.201,3.781.846,7.755-.604,10.928-2.828s5.745-5.18,8.556-7.847c15.896-15.082,35.766-18.746,58.068-18.972,7.321.225,27.821-1.802,33.173,11.4.998,2.458,1.37,5.121,1.63,7.761.514,5.221.522,10.861-2.366,15.241-2.453,3.721-6.706,5.966-11.069,6.879s-8.879.64-13.32.253c-6.215-1.01-8.419-7.075-8.499-9.32-.215-5.993.086-12.798,5.356-15.66,2.097-1.139,4.539-1.464,6.924-1.543,3.24-.108,6.651.254,9.339,2.067s4.375,5.417,3.141,8.415c-1.326,3.222-5.976,6.985-14.221,3.216",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.996,804.906c-2.258.432-4.565.708-6.857.528-5.725-.45-13.994-3.515-17.342-8.181s-8.491-18.7,1.415-29.313c4.549-4.65,13.9-5.476,16.274-5.458,5.38.041,10.127,1.844,13.039,6.368,1.818,2.824,3.156,7.994,2.333,11.25s-2.307,6.354-5.188,9.374",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.613,762.518c-7.621-.112-18.041.841-25.07,4.962-1.477.866-2.937,1.767-4.424,2.618-22.939,13.121-28.22,33.188-45.123,34.809",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.191,762.802c-7.621-.112-18.041.841-25.07,4.962-1.477.866-2.937,1.767-4.424,2.618-22.939,13.121-28.441,33.359-45.343,34.98",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2,762.978c-7.621-.112-20.282,5.927-21.768,6.777-22.939,13.121-26.534,33.949-43.436,35.57",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.199,779.209c-31.093,11.088-27.002,24.63-43.904,26.251",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g",
    "data-name": "pillar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "h",
    "data-name": "pillar"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.28 1.5 304.794 1.5 291.746 19.209 18.193 18.743 3.28 1.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.688,128.426c-2.966-3.347-2.155-6.185-.603-8.187,1.611-2.078,4.195-3.165,6.825-3.151,0,0,177.37.917,177.37.917.935.283,10.145,4.245,1.748,11.942",
    fill: "#efefef",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.52,302.46l-183.15-.805-.439-172,182.679.466M102.81,300.877c0-47.244-1.072-133.182-1.365-142.65-.13-16.803-25.856-16.919-25.663,0,.228,12.39-.379,107.489-.379,143.318M146.26,300.877c0-47.244-.123-132.223-.416-141.691-.13-16.803-25.856-16.919-25.663,0,.362,10.377.678,94.446.678,141.691M189.71,300.877c0-35.394.823-132.108.53-141.575-.13-16.803-25.856-16.919-25.663,0-.095,13.638,1.069,106.682,1.069,142.244M233.829,300.877c0-47.244.996-131.759.703-141.226-.13-16.803-25.856-16.919-25.663,0,.362,10.377.895,94.65.895,141.895",
    fill: "#efefef",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.028,129.946l.457,171.284",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.931,129.655h0c-1.197.021-2.38-.398-3.243-1.229",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.591,
    y1: 88.762,
    x2: 262.736,
    y2: 89.461,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.174,
    y1: 70.471,
    x2: 274.037,
    y2: 71.403,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.407,
    y1: 78.51,
    x2: 261.921,
    y2: 78.859,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.387,
    y1: 103.791,
    x2: 272.057,
    y2: 104.49,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.231,71.519c.85,1.033,1.893,2.01,1.631,3.903-.306,1.302-.993,2.599-2.214,3.146-1.041.466-2.214.233-3.961.291,5.825.32,8.376,7.159.728,10.631.336.797,10.955,14.237,9.874,15.349-.654.673-4.248,1.41-5.136,1.714-1.741.596-3.469,1.229-5.182,1.899-3.1,1.212-6.179,2.558-8.888,4.491s-5.049,4.505-6.234,7.615",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.96,70.587c-6.058.058-9.612,7.922,2.629,7.88-9.095,1.79-6.47,9.282-.969,10.294-.336.797-10.714,14.574-9.633,15.686.654.673,4.248,1.41,5.136,1.714,1.741.596,3.469,1.229,5.182,1.899,3.1,1.212,6.179,2.558,8.888,4.491s5.049,4.505,6.234,7.615",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.021,71.421c10.131.038,6.928-9.225-.224-8.821l-240.589-.988c-7.151-.404-10.355,8.858-.224,8.821",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.028,
    y1: 104.607,
    x2: 244.911,
    y2: 118.587,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 236.756,
    y1: 104.607,
    x2: 236.756,
    y2: 117.772,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.066,
    y1: 104.257,
    x2: 229.066,
    y2: 117.772,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.795,
    y1: 104.374,
    x2: 220.911,
    y2: 117.888,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.493,
    y1: 104.215,
    x2: 213.389,
    y2: 117.756,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.056,
    y1: 104.215,
    x2: 205.056,
    y2: 117.756,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 197.101,
    y1: 104.754,
    x2: 197.101,
    y2: 117.919,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.411,
    y1: 104.405,
    x2: 189.411,
    y2: 117.919,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.14,
    y1: 104.521,
    x2: 181.256,
    y2: 118.036,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.838,
    y1: 104.362,
    x2: 173.734,
    y2: 117.903,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.401,
    y1: 104.362,
    x2: 165.401,
    y2: 117.903,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 157.593,
    y1: 104.495,
    x2: 157.593,
    y2: 117.66,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.904,
    y1: 104.146,
    x2: 149.904,
    y2: 117.66,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.632,
    y1: 104.262,
    x2: 141.749,
    y2: 117.777,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.331,
    y1: 104.104,
    x2: 134.226,
    y2: 117.645,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.894,
    y1: 104.104,
    x2: 125.894,
    y2: 117.645,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 117.386,
    y1: 104.097,
    x2: 117.386,
    y2: 117.262,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.697,
    y1: 103.748,
    x2: 109.697,
    y2: 117.262,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.425,
    y1: 103.864,
    x2: 101.541,
    y2: 117.379,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.123,
    y1: 103.706,
    x2: 94.019,
    y2: 117.247,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.686,
    y1: 103.706,
    x2: 85.686,
    y2: 117.247,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 77.975,
    y1: 104.296,
    x2: 77.975,
    y2: 117.461,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.286,
    y1: 103.947,
    x2: 70.286,
    y2: 117.461,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.014,
    y1: 104.063,
    x2: 62.13,
    y2: 117.578,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.4,46.894c2.679,2.104,7.064.943,8.82-1.976s1.054-6.911-1.169-9.492c-1.378-1.6-3.28-2.74-5.341-3.201-3.781-.846-7.755.604-10.928,2.828-3.173,2.224-5.745,5.18-8.556,7.847-15.896,15.082-35.766,18.746-58.068,18.972-7.321-.225-27.821,1.802-33.173-11.4-.998-2.458-1.37-5.121-1.63-7.761-.514-5.221-.522-10.861,2.366-15.241,2.453-3.721,6.706-5.966,11.069-6.879,4.363-.913,8.879-.64,13.32-.253,6.215,1.01,8.419,7.075,8.499,9.32.215,5.993-.086,12.798-5.356,15.66-2.097,1.139-4.539,1.464-6.924,1.543-3.24.108-6.651-.254-9.339-2.067s-4.375-5.417-3.141-8.415c1.326-3.222,5.976-6.985,14.221-3.216",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.456,19.621c2.258-.432,4.565-.708,6.857-.528,5.725.45,13.994,3.515,17.342,8.181,3.347,4.666,8.491,18.7-1.415,29.313-4.549,4.65-13.9,5.476-16.274,5.458-5.38-.041-10.127-1.844-13.039-6.368-1.818-2.824-3.156-7.994-2.333-11.25.824-3.256,2.307-6.354,5.188-9.374",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.839,62.009c7.621.112,18.041-.841,25.07-4.962,1.477-.866,2.937-1.767,4.424-2.618,22.939-13.121,28.22-33.188,45.123-34.809",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.261,61.725c7.621.112,18.041-.841,25.07-4.962,1.477-.866,2.937-1.767,4.424-2.618,22.939-13.121,28.441-33.359,45.343-34.98",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.252,61.548c7.621.112,20.282-5.927,21.768-6.777,22.939-13.121,26.534-33.949,43.436-35.57",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.253,45.318c31.093-11.088,27.002-24.63,43.904-26.251",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "j",
    "data-name": "right_swirl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.584,46.186c-2.679,2.104-7.064.943-8.82-1.976s-1.054-6.911,1.169-9.492c1.378-1.6,3.28-2.74,5.341-3.201,3.781-.846,7.755.604,10.928,2.828s5.745,5.18,8.556,7.847c15.896,15.082,35.766,18.746,58.068,18.972,7.321-.225,27.821,1.802,33.173-11.4.998-2.458,1.37-5.121,1.63-7.761.514-5.221.522-10.861-2.366-15.241-2.453-3.721-6.706-5.966-11.069-6.879-4.363-.913-8.879-.64-13.32-.253-6.215,1.01-8.419,7.075-8.499,9.32-.215,5.993.086,12.798,5.356,15.66,2.097,1.139,4.539,1.464,6.924,1.543,3.24.108,6.651-.254,9.339-2.067s4.375-5.417,3.141-8.415c-1.326-3.222-5.976-6.985-14.221-3.216",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.528,18.914c-2.258-.432-4.565-.708-6.857-.528-5.725.45-13.994,3.515-17.342,8.181-3.347,4.666-8.491,18.7,1.415,29.313,4.549,4.65,13.9,5.476,16.274,5.458,5.38-.041,10.127-1.844,13.039-6.368,1.818-2.824,3.156-7.994,2.333-11.25s-2.307-6.354-5.188-9.374",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.144,61.301c-7.621.112-18.041-.841-25.07-4.962-1.477-.866-2.937-1.767-4.424-2.618-22.939-13.121-28.22-33.188-45.123-34.809",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.723,61.018c-7.621.112-18.041-.841-25.07-4.962-1.477-.866-2.937-1.767-4.424-2.618-22.939-13.121-28.441-33.359-45.343-34.98",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.731,60.841c-7.621.112-20.282-5.927-21.768-6.777-22.939-13.121-26.534-33.949-43.436-35.57",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.731,44.611c-31.093-11.088-27.002-24.63-43.904-26.251",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarIllustration);
export default __webpack_public_path__ + "static/media/pillarIllustration.4433517ea11cd4df33d05e6f1973abd6.svg";
export { ForwardRef as ReactComponent };